import { DISPLAY_IMAGE_CDN, type DisplayImage } from './api';

export const DISPLAY_IMAGE_WIDTHS = {
  thumbnail: 160,
  detail: 1200,
} as const;

function applyAmazonSize(url: string, width: number): string {
  return url.replace(/\.(jpe?g|png)$/i, `._SL${width}_.$1`);
}

function applyWalmartSize(url: string, width: number): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('odnWidth', String(width));
    parsed.searchParams.set('odnHeight', String(width));
    return parsed.toString();
  } catch {
    return url;
  }
}

function applyShopifySize(url: string, width: number): string {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('width', String(width));
    return parsed.toString();
  } catch {
    return url;
  }
}

export function getSizedImageUrl(image: DisplayImage, width: number): string {
  switch (image.cdn) {
    case DISPLAY_IMAGE_CDN.Amazon:
      return applyAmazonSize(image.url, width);
    case DISPLAY_IMAGE_CDN.Walmart:
      return applyWalmartSize(image.url, width);
    case DISPLAY_IMAGE_CDN.Shopify:
      return applyShopifySize(image.url, width);
    default:
      return image.url;
  }
}
